import './components/notification.component';
import './components/question-answer-box.component';
import { LanguagePickerComponent } from "./components/language-picker.component";
import { NavComponent } from "./components/nav.component";
import { FooterComponent } from "./components/footer.component";
import { PrivacyPolicyPage } from "./pages/privacy-policy.page";
import { JobOfferLayout } from "./layouts/job-offer.layout";
import { OurCustomersSectionComponent } from "./components/our-customers-section.component";
import { HomePage } from "./pages/home.page";
import { HomePageAppsSliderComponent } from "./components/home-page-apps-slider.component";
import { MaintenanceWithTeamviewerPage } from "./pages/maintenance-with-teamviewer.page";
import { SupportPage } from "./pages/support.page";
import { PricesPage } from "./pages/prices.page";
import { WebAppLayout } from "./layouts/web-app.layout";
import { ContactPage } from "./pages/contact.page";
import { DesktopAppsPage } from './pages/desktop-apps.page';
import { JobFinderLayout } from "./layouts/job-finder.layout";
import { Meta } from './classes/Meta';
import { AboutPage } from './pages/about.page';
import { CareerPage } from "./pages/career.page";
import { SearchComponent } from "./components/search.component";
import { SearchPage } from "./pages/search.page";
import {AwsPage} from "./pages/aws.page";
import '../../node_modules/video.js/dist/video';
import '../../node_modules/cc-cookies';
import { DefaultLayout } from "./layouts/default.layout";
// import { IbcPage } from "./pages/ibc.page";
import './components/ibc-banner.component';

const footerComponent = new FooterComponent();

footerComponent.init();

new DefaultLayout(footerComponent).init();
new LanguagePickerComponent().init();
new NavComponent().init();
new PrivacyPolicyPage().init();
new HomePage().init();
new JobOfferLayout().init();
new OurCustomersSectionComponent().init();
new HomePageAppsSliderComponent().init();
new MaintenanceWithTeamviewerPage().init();
new SupportPage().init();
new PricesPage().init();
new WebAppLayout().init();
new ContactPage().init();
new JobFinderLayout().init();
new DesktopAppsPage().init();
new Meta().init();
new AboutPage().init();
new CareerPage().init();
new SearchComponent().init();
new SearchPage().init();
new AwsPage().init();
// new IbcPage().init();
